import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Stack,
  Divider,
  useTheme,
  useMediaQuery
} from '@mui/material';
import logo from '../images/MF-Logo1.png';

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box id="footer"
      sx={{
        py: 4,
        // mx: 2,
        backgroundColor: 'background.main',
        color: 'white',
        mt: isMobile ? 2 : 4,
        mb: isMobile ? 36 : "auto",
        // borderTop: '1px solid rgba(255,255,255,0.2)',
      }}
    >

      <Container maxWidth="lg"
        sx={{
          cursor: 'default',
          // pb: isMobile ? 42 : 'inherit',
        }}
      >
        <Divider sx={{ mb: 3, borderColor: 'rgba(255,255,255,0.2)' }} />
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Stack direction="row" spacing={2}
              sx={{
                mb: 2,
                mt: .5,
                alignItems: 'center',
                // justifyContent: 'center',
              }}
            >
              <img
                src={logo}
                alt="Maximal Construction Logo"
                style={{
                  height: '30px',
                  width: 'auto',
                  pb: 1,
                  pr: 0,
                }}
              />
              <Typography
                variant="h6"
                sx={{
                  mb: 2,
                  fontFamily: '"Nexa Slab Bold", serif',
                  fontWeight: 700,
                  letterSpacing: 1.5,
                  color: 'primary.main',
                  textTransform: 'uppercase',
                  ml: '8px !important',
                }}
              >
                MAXIMAL
                <span style={{ color: 'white', fontWeight: 100 }}> FLOORING</span>
              </Typography>
            </Stack>
            <Typography variant="body2" sx={{ mb: 2 }}>
              Premium flooring services with unmatched quality.
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography
              variant="h6"
              sx={{
                mb: 2,
                fontWeight: 600
              }}
            >
              Services
            </Typography>
            <Stack spacing={1}>
              <Typography variant="body2">Custom Flooring</Typography>
              <Typography variant="body2">Production Flooring</Typography>
              <Typography variant="body2">Commercial Flooring</Typography>
              <Typography variant="body2">Wall Tile</Typography>
              <Typography variant="body2">Renovation</Typography>
            </Stack>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography
              variant="h6"
              sx={{
                mb: 2,
                fontWeight: 600
              }}
            >
              Contact Info
            </Typography>
            <Stack spacing={1}>
              <Typography variant="body2">(615) 477-3695</Typography>
              <Typography variant="body2"
                sx={{
                  cursor: 'pointer',
                  '&:hover': {
                    color: 'primary.main',
                  }
                }}
                onClick={() => window.location.href = 'mailto:info@maximalflooring.com'}
              >
                info@maximalflooring.com
              </Typography>
              {/* <Typography variant="body2">123 Construction Ave, City, State 12345</Typography> */}
            </Stack>
          </Grid>
        </Grid>
        <Divider sx={{ my: 3, borderColor: 'rgba(255,255,255,0.2)' }} />
        <Typography
          variant="body2"
          align="center"
          sx={{ opacity: 0.7 }}
        >
          © 2025 Maximal Flooring. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer; 